import { toast } from 'react-toastify';

const notifyBrowser = (title: string, body: string) => {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  new Notification(title, { body });
};

type LongPingStatus = 'success' | 'completed' | 'interrupted' | 'failed' | string;

export const notifyLongPingResult = (label: string, status: LongPingStatus, result?: string) => {
  if (status === 'success' || status === 'completed') {
    toast.success(
      <span>
        Long ping test on {label} completed.{' '}
        <a href={result} target="_blank" rel="noopener noreferrer">Download long ping report</a>
      </span>,
      { autoClose: false },
    );
    notifyBrowser('Long Ping Test Completed', `Long ping test on ${label} completed successfully.`);
  } else if (status === 'interrupted') {
    toast.warn(
      <span>
        Long ping test on {label} was interrupted.{' '}
        <a href={result} target="_blank" rel="noopener noreferrer">Download shortened long ping report</a>
      </span>,
      { autoClose: false },
    );
    notifyBrowser('Long Ping Test Interrupted', `Long ping test on ${label} was interrupted; shortened report is available.`);
  } else {
    toast.error(`Long ping test on ${label} failed: ${result}`, { autoClose: false });
    notifyBrowser('Long Ping Test Failed', `Long ping test on ${label} failed: ${result}`);
  }
};
